module.exports = __webpack_public_path__ + "static/3-d1adf4679773d3888391fb729b2ce918.png";